<template>
  <div class="cf-card cf-flex cf-flex--row cf-flex--align-cente cf-flex--justify-space-between">
    <div class="cf-flex cf-flex--column cf-flex--gap-16">
      <h3 class="cf-title cf-title--3">
        {{ bannerContent.title }}
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        {{ bannerContent.message }}
      </p>
    </div>

    <span class="cf-icon cf-icon--large far fa-gift" />
  </div>
</template>


<script>
  export default {
    name: 'UnEarnedRewardsBanner',

    props: {
      bannerContent: {
        type: Object,
        required: true
      }
    }
  };
</script>
